import React from 'react';
import Styled from 'styled';
import SVGIcon from 'lib/images/svg-icon/svg-icon';

import close from 'four-nets/icons/svg/icon_close.svg';
import defaultStyles from './autocomplete-result-view.scss';


@Styled(defaultStyles)
class AutocompleteResultView extends React.PureComponent {
    onClick = event => {
        event.preventDefault();
        this.props.onRemoveClick();
    };

    render() {
        const { styles, label } = this.props;

        return (
            <div className={styles.autocompleteResult}>
                <span className={styles.label}>{label}</span>
                <button type='button' className={styles.button} onClick={this.onClick}>
                    <SVGIcon style={{image: styles.icon}} src={close} />
                </button>
            </div>
        );
    }
}

export default AutocompleteResultView;
